import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_LOADING,
  SET_UPDATES_LOADING,
  UPDATE_FILTERS_SUCCESS,
  FETCH_SCORECARDS,
  FETCH_TABLE_DATA,
  RESET_ALL_FILTERS,
  UPDATE_TYPE
} from "./sagas/userLoginSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filtersDirty: false,
  filters: [],
  selectedFilters: [],
  scorecards: {
    topScorecards: [],
    bottomScorecards: []
  },
  tableInfo: {
    userActivity: [],
    topNumberLogins: [],
    daysSinceLastLogin: []
  },
  currentType: "User",
  typeOptions: ["User", "Store"],
  selectedTypeOption: "User"
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),

    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: { ...action.payload }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: action.payload
    }),
    [FETCH_SCORECARDS]: (state, action) => ({
      ...state,
      scorecards: action.payload,
      currentType: state.selectedTypeOption
    }),
    [FETCH_TABLE_DATA]: (state, action) => ({
      ...state,
      tableInfo: {
        ...state.tableInfo,
        ...action.payload
      }
    }),
    [UPDATE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      selectedFilters: action.payload,
      filtersDirty: true
    }),
    [UPDATE_TYPE]: (state, action) => ({
      ...state,
      selectedTypeOption: action.payload,
      filtersDirty: true
    }),
    [RESET_ALL_FILTERS]: (state) => ({
      ...state,
      selectedFilters: [],
      selectedTypeOption: initialState.selectedTypeOption
    })
  },
  initialState
);
